import React from "react";
import { ProgressStepper } from "../ProgressStepper";

interface Props {
  currentStep: number;
}

const DISCONNECTION_FORM_STEPS = ["Service Type", "Order Details", "Review"];

export const DisconnectionProgressStepper: React.FC<Props> = ({ ...props }) => {
  return <ProgressStepper steps={DISCONNECTION_FORM_STEPS} {...props} />;
};

export { DISCONNECTION_FORM_STEPS };
